<template>

    <div class="switch-container">

        <select v-model="selected" :class="{ 'select-lang-switch-white': white, 'select-lang-switch-green': green }" class="select-lang-switch" @change="updateLang" @click="selectedFocused">

            <template v-for="(lang, min) in languages">

                <option :value="min" class="option-lang-switch">{{ lang }}</option>

            </template>

        </select>

    </div>

</template>

<script>

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'

import Languages from '@/assets/languages.json'

export default {

    name: 'lang-switch',

    props: {

        white: {
            type: Boolean,
            default: false
        },

        green: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            selected: '',
            languages: {}
        }
    },

    mounted() {

        this.selected = localStorage.getItem('lang') || I18n.get(this)

        this.languages = Languages

    },

    methods: {

        updateLang() {
            I18n.set(this, this.selected)
        },

        selectedFocused() {
            Tag.clickAmplitude(this, 'edit_language')
        }

    }

}

</script>

<style lang="scss" scoped>

.select-lang-switch {
    width: 192px;
    height: 40px;
    border-radius: 4px;
    padding: 0 16px;
    font-size: 16px;
    line-height: 1.75;
    color: $white;
    border: none;
    /*firefox*/
    -webkit-appearance: none;
    -moz-appearance: none;
    background: url(data:image/gif;base64,R0lGODlhCwALAJEAAAAAAP///xUVFf///yH5BAEAAAMALAAAAAALAAsAAAIPnI+py+0/hJzz0IruwjsVADs=);
    background-repeat: no-repeat;
    background-position: 95% 42%;
    background-color: rgb(122, 192, 237);
}

.select-lang-switch-white {
    background-color: $timberwolf;
    color: $midnight;
}

.select-lang-switch > option-lang-switch {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: $white;
    background-color: rgba(255, 255, 255, 0.2);
}

.select-lang-switch-green {
    background-color: $forest;
    color: $white;
    border-radius: 40px;
    width: 120px;
}

</style>
